/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactregisterednoticetitle3Inputs */

const en_artifactregisterednoticetitle3 = /** @type {(inputs: Artifactregisterednoticetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered notice (interpelação admonitória)`)
};

const pt_artifactregisterednoticetitle3 = /** @type {(inputs: Artifactregisterednoticetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificação registada (interpelação admonitória)`)
};

/**
* | output |
* | --- |
* | "Registered notice (interpelação admonitória)" |
*
* @param {Artifactregisterednoticetitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactregisterednoticetitle3 = /** @type {((inputs?: Artifactregisterednoticetitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactregisterednoticetitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactregisterednoticetitle3(inputs)
	return pt_artifactregisterednoticetitle3(inputs)
});
export { artifactregisterednoticetitle3 as "artifactRegisteredNoticeTitle" }